<template>
  <div class="row justify-content-center">
    <div class="col-sm-12">
      <h5 class="info-text">選擇圖文選單</h5>
    </div>
    <div class="col-sm-3 offset-sm-1" v-for="richmenu in richmenus" :key="richmenu.id">
      <card style="width: 100%;">
        <img slot="image" class="card-img-top" :src="richmenu.imageUrl" alt="Card image cap">
        <div>
          <h4 class="card-title">{{richmenu.displayName}}</h4>
          <p class="card-text">{{richmenu.fileName}}</p>
          <n-button :type="calType(richmenu.selected)" @click.native="clickRichmenu(richmenu.id)" :key="richmenu.id + richmenu.fileName">{{richmenu.selectedContent}}</n-button>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { IconCheckbox } from "src/components";
import { fetchShops, fetchRichmenus } from "../../../../javascripts/generalPages/fetchData";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    IconCheckbox
  },
  created: function() {
    fetchRichmenus()
    .then(res => {
      this.richmenus.push(...res.data)
      this.richmenus.forEach((richmenu, index) => {
        richmenu.fileName = `${richmenu.style}_${richmenu.fileName}`;
        if(index === 0) {
          richmenu = Object.assign({}, {...richmenu, selected: true, selectedContent: "已選擇"});
          this.$set(this.richmenus, index, richmenu)
        } else {
          richmenu = Object.assign({}, {...richmenu, selected: false, selectedContent: "可選擇"});
          this.$set(this.richmenus, index, richmenu)
        }
      });
    })
    .catch(err => {
      console.log("err: ", err);
    })
  },
  data() {
    return {
      richmenus: [
        // {
        //   id: 1,
        //   imageUrl: "https://storage.cloud.google.com/qc_staging_products/jessica_catering-reviewPlusFB_A01.jpg?authuser=4&folder&hl=zh-TW&organizationId",
        //   displayName: "行銷選單",
        //   fileName: "jessica_catering-basic",
        //   selected: true,
        //   selectedContent: "已選擇"
        // },
        // {
        //   id: 2,
        //   imageUrl: "https://storage.cloud.google.com/qc_staging_products/jessica_catering-reviewPlusFB_A01.jpg?authuser=4&folder&hl=zh-TW&organizationId",
        //   displayName: "基本選單",
        //   fileName: "basic",
        //   selected: false,
        //   selectedContent: "可選擇"
        // }
      ],
      selectedRichmenu: {}
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    clickRichmenu(richmenuId) {
      this.richmenus.forEach(richmenu => {
        if(richmenuId === richmenu.id) {
          richmenu.selected = true;
          richmenu.selectedContent = "已選擇";
        } else {
          richmenu.selected = false;
          richmenu.selectedContent = "可選擇";
        }
      });
    },
    calType(isSelected) {
      if(isSelected) return "success";
      return "info"
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.selectedRichmenu.richmenu = this.richmenus.find(richmenu => {
          return richmenu.selected === true;
        })
        this.$emit("on-validated", res, this.selectedRichmenu);
        return res;
      });
    },
    finish() {
      this.selectedRichmenu = this.richmenus.find(richmenu => {
        return richmenu.selected === true;
      })
    }
  }
}
</script>
<style>
</style>
